
$('.detail-imageslider .owl-carousel').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    dots:false,
    // autoplay:true,
    // autoplaytimeout:2000,
    responsive:{
        0:{
            items:1
        },
        576:{
            items:1
        },
        768:{
            items:1
        },
        1024:{
            items:1
        },
        1366:{
            items:1
        },
        1920:{
            items:1
        }
    }
});

$('.accessoires-slider .owl-carousel').owlCarousel({
    loop:false,
    margin:33,
    nav:true,
    dots:false,
    // autoplay:true,
    // autoplaytimeout:2000,
    responsive:{
        0:{
            items:1
        },
        576:{
            items:2
        },
        768:{
            items:3
        },
        1024:{
            items:3
        },
        1366:{
            items:4
        },
        1920:{
            items:4
        }
    }
});

function myFunction(x) {
  x.classList.toggle("change");
}

jQuery(window).load(function() {
  jQuery("#loader-wrapper").fadeOut("slow");
});
$(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox();
            });



$('#accesoiresdata-select').on('change', function (e) {
    $('#myTab li a').eq($(this).val()).tab('show'); 
});